import { createStore, combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

// App middleware
import enhancements from '../middlewares/MiddlewareContainer';

// App state
import { state } from '../store/state';

// App reducers
import upload from '../reducers/upload';
import crop from '../reducers/crop';
import result from '../reducers/result';

// Combine all app reducers and router reducer.
const reducer = combineReducers({
  upload,
  crop,
  result,
  router: routerReducer,
});

/**
 * - Add the reducer and the default store tree to the store.
 * - Apply middlewares.
 */
const store = createStore(
  reducer,
  state,
  enhancements,
);

export default store;



// WEBPACK FOOTER //
// ./src/store/StoreContainer.js